import { createORPCClient } from '@orpc/client'
import { RPCLink } from '@orpc/client/fetch'
import { createTanstackQueryUtils } from '@orpc/tanstack-query'
import type { AppRouterClient } from './router'

/**
 * Cookie-credentialed oRPC + TanStack Query utils for browser SPAs (#576).
 * Pass the public API origin (e.g. env.apiUrl).
 */
export function createBrowserOrpc(apiUrl: string) {
  const link = new RPCLink({
    url: `${apiUrl}/v1/rpc`,
    // Browser-only: Workers `RequestInit` types omit `credentials`. Cast for SPA.
    fetch: (url, options) =>
      globalThis.fetch(
        url as RequestInfo,
        { ...(options as RequestInit), credentials: 'include' } as RequestInit,
      ),
  })
  const client: AppRouterClient = createORPCClient(link)
  const orpc = createTanstackQueryUtils(client)
  return { link, client, orpc }
}
